module.exports = __webpack_public_path__ + "img/icon_sort_asc_active.49f36415.svg";